module.exports = __webpack_public_path__ + "static/media/unauthorized.7ae3a7a3.svg";